import React from "react";
import "./services.css";
import { BiCheck } from "react-icons/bi";

const Services = () => {
  return (
    <section id="services">
      <h5>What I Offer</h5>
      <h2>Services</h2>
      <div className="container services__container">
        <article className="service">
          <div className="service__head">
            <h3>Frontend Development</h3>
          </div>
          <ul className="service__list">
            <li>
              <BiCheck className="service__list-icon" />
              <p>Web Design</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Web Development</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Page Speed Optimization</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Responsive Layouts</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Hand Coded Websites</p>
            </li>
          </ul>
        </article>
        {/* END OF FRONTEND */}
        <article className="service">
          <div className="service__head">
            <h3>Backend Development</h3>
          </div>
          <ul className="service__list">
            <li>
              <BiCheck className="service__list-icon" />
              <p>Troubleshoot and debugging applications</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Conducting UI tests and optimizing performance.</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Develop websites with clean code.</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Maintain code databases</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Managing API's.</p>
            </li>
          </ul>
        </article>
        {/* END OF BACKEND */}
        {/* <article className="service">
          <div className="service__head">
            <h3>iOS Development</h3>
          </div>
          <ul className="service__list">
            <li>
              <BiCheck className="service__list-icon" />
              <p>Lorem, ipsum dolor sit amet consectetur elit.</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Lorem, ipsum dolor sit amet consectetur elit.</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Lorem, ipsum dolor sit amet consectetur elit.</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Lorem, ipsum dolor sit amet consectetur elit.</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Lorem, ipsum dolor sit amet consectetur elit.</p>
            </li>
          </ul>
        </article> */}
        {/* END OF FRONTEND */}
      </div>
    </section>
  );
};

export default Services;
